// extracted by mini-css-extract-plugin
module.exports = {"container":"UserInfo_container__QJAM2","name":"UserInfo_name__GefnN","avatar":"UserInfo_avatar__t3TqK","link":"UserInfo_link__iMOvm"};